<template>
  <div class="month atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="month-title">
        <h2>{{ this.detail.resWkName ? this.detail.title + ' / ' + this.detail.resWkName : '' }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="tab atb-flex atb-flex-justify-between">
        <tab-pane :defaultIndex="currentTab" :tab-list="tabList" iconStyle="top" @getCurrent="getCurrent"></tab-pane>
        <div class="open" @click="expandSearch">
          筛选
          <i :class="[expandSearchStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
        </div>
      </div>
      <div v-show="currentTab === 0" class="search-and-content atb-flex atb-flex-column" id="all">
        <div class="search">
          <el-form v-if="expandSearchStatus" :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('search')" @submit.native.prevent>
            <el-form-item class="flex-form-item" label="类别">
              <el-autocomplete v-model="searchParam.WorkItemCategory" :fetch-suggestions="querySearch"></el-autocomplete>
            </el-form-item>
            <el-form-item class="flex-form-item" label="分类">
              <el-select clearable v-model="searchParam.WorkClassify" placeholder="分类">
                <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="完成情况">
              <el-select clearable v-model="searchParam.CompleteStatus" placeholder="完成情况">
                <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="关键字">
              <el-input v-model="searchParam.KeyWord" placeholder="工作项目"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList('search')">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input model">
              <el-form-item>
                <el-radio-group v-model="model" @change="changeModel">
                  <el-radio label="1">完整模式</el-radio>
                  <el-radio label="2">计划模式</el-radio>
                  <el-radio label="3">总结模式</el-radio>
                  <el-radio label="4">汇报模式</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="editStatus == 'edit' && status !== 10">
                <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-button :disabled="pending" type="primary" @click="copyPreviousMonthPlan">复制</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit'">
                <el-button type="primary" @click="submitHandle">提交</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' || editStatus==='manage'">
                <el-button plain type="import" @click="exportExcel">导出</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-upload ref="file" :http-request="uploadFile" :multiple="false" :show-file-list="false">
                  <el-button plain type="import">导入</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-button plain type="downloadTemplate" @click="downloadTemplate">下载模板</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'approve'">
                <el-button :disabled="disabledApprove" type="primary" @click="showApprove = true">通过</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'approve'">
                <el-button :disabled="disabledApprove" type="refuse" @click="showCompleteApprove = true">驳回</el-button>
              </el-form-item>
              <el-form-item>
                <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && status !== 10">
                <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                  <el-button type="import" plain class="menu-button">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="a">本月目标完成时间</el-dropdown-item>
                    <el-dropdown-item command="b">总目标完成时间</el-dropdown-item>
                    <el-dropdown-item command="c">完成情况</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
              <el-form-item v-if="editStatus==='manage'">
                <el-button type="downloadTemplate" plain @click="preciseExport">精确导出</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column kpi">
          <div v-show="showCollapse" class="collapse" @click="collapse($refs.month, tableColumn, 'kpi')">
            <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
          </div>
          <vxe-table
            class="atb-table header-table edit-table border-table disable-ellipsis"
            border="full"
            height="100%"
            auto-resize
            resizable
            :data="tableData"
            ref="month"
            :merge-cells="mergeCells"
            :row-class-name="setRowClass"
            :cell-class-name="setCellClass"
            :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
            @edit-closed="editClosed"
            @edit-actived="activeRow"
            @cell-click="expandRow"
            :edit-rules="validRules"
          >
            <vxe-table-column type="checkbox" width="40" align="center">
              <template #checkbox="scope">
                <template v-if="scope.rowIndex === 0">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandKpi" :class="[expandKpiStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandKpi">KPI工作</span>
                      <i v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addKpi" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addKpi(scope.row)">新增</span>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === kpiLength + 1">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandNormal" :class="[expandBudgetStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandNormal">费效管理</span>
                      <i v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addBudget" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addBudget">新增</span>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === kpiLength + budgetLength + 2">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandCreate" :class="[expandCreateStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandCreate">问题及创新工作</span>
                      <i v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addCreate" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addCreate">新增</span>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === kpiLength + budgetLength + createLength + 3">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandOther" :class="[expandOtherStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandOther">其他新增工作</span>
                      <!--                    <i v-if='status === 0 || status === 30' @click="addOther" class="icon-add"></i>-->
                    </div>
                    <!--                  <span v-if='status === 0 || status === 30' @click='addOther'>新增</span>-->
                  </div>
                </template>
                <template v-else>
                  <span
                    v-if="status !== 10"
                    title="选择/取消"
                    :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']"
                    @click.stop="selectSingle(scope.row)"
                  >
                    <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                    <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                    <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                  </span>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="40" title="源">
              <template #default="{row}">
                <div class="atb-flex atb-flex-items-center">
                  <i v-if="row.source === 1" class="icon-tubiao-99 source-icon add"></i>
                  <i v-else-if="row.source === 2" class="icon-tubiao-96 source-icon pre"></i>
                  <i v-else-if="row.source === 3" class="icon-tubiao-99 source-icon self"></i>
                  <i v-else-if="row.source === 4" class="icon-tubiao-95 source-icon year"></i>
                  <i v-else-if="row.source === 7" class="icon-zhuan source-icon zhuan"></i>
                  <i v-else-if="row.source === 8" class="icon-jiao source-icon jiao"></i>
                  <i v-else-if="row.source === 9" class="icon-todo-work source-icon todo"></i>
                  <i v-else></i>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
              <template #default="scope">
                <span v-if="scope.rowIndex <= kpiLength">{{ scope.rowIndex }}</span>
                <span v-else-if="scope.rowIndex > kpiLength + 1 && scope.rowIndex <= budgetLength + kpiLength + 2">{{
                  scope.rowIndex - kpiLength - 1
                }}</span>
                <span v-else-if="scope.rowIndex > budgetLength + kpiLength + 2 && scope.rowIndex <= budgetLength + kpiLength + createLength + 3">{{
                  scope.rowIndex - kpiLength - budgetLength - 2
                }}</span>
                <span v-else>{{ scope.rowIndex - kpiLength - createLength - budgetLength - 3 }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="60"
              width="100"
              field="workItemCategory"
              title="类别"
              :edit-render="{ name: 'ElAutocomplete', enabled: categoryAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
              </template>
              <template #edit="{ row }">
                <el-autocomplete v-model.lazy="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                  <template slot-scope="{ item }">
                    <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                      <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                    </el-tooltip>
                  </template>
                </el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="model == 4 ? null : 150"
              field="workItemContent"
              title="工作项目"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.workItemContent"
                ></el-input>
              </template>
              <template #default="scope">
                <div class="atb-flex atb-flex-items-center" @contextmenu.prevent="popupHistory(scope.row)">
                  <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}</div>
                  <el-popover
                    placement="right"
                    v-if="scope.row.isPublished == 1"
                    width="416"
                    height="200"
                    popper-class="history"
                    trigger="hover"
                    @show="getAddWork(scope.row)"
                    :visible-arrow="false"
                  >
                    <el-checkbox-group v-model="checkList" class="program-check">
                      <li class="atb-flex" v-for="item in programData" :key="item.id">
                        <el-checkbox :label="item.id">
                          <span>{{ item.resWkName }}</span>
                        </el-checkbox>
                        <div>
                          <p class="desc">{{ item.workItemContent }}</p>
                          <p class="date">{{ $formatTime(item.currentMonthFinishDate, 'yyyy-MM-dd') }}</p>
                        </div>
                      </li>
                    </el-checkbox-group>
                    <div class="footer">
                      <el-checkbox class="select-all-program" @change="checkAll" v-model="selectAllProgram">全选</el-checkbox>
                      <el-button class="atb-dialog-confirm copy" type="primary" @click="copyProgram">复制</el-button>
                    </div>
                    <span slot="reference" class="program-tip">
                      <i class="icon-synchronize"></i>
                    </span>
                  </el-popover>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" field="resWkName" title="责任人" :edit-render="{ enabled: false }">
              <template #edit="{ row }">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="row.resWkName"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="80"
              width="250"
              field="wholeTarget"
              title="总目标"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
              </template>
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.wholeTarget"
                ></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="150"
              field="finishDate"
              title="总目标完成时间"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
              <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            <vxe-table-column
              min-width="160"
              :width="model == 4 ? null : 250"
              field="currentMonthTarget"
              title="本月需达到的目标"
              :edit-render="{ enabled: fromOtherAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row, rowIndex}">
                <div class="atb-flex atb-flex-items-center">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.currentMonthTarget }}
                  </div>
                  <el-tooltip class="item" effect="dark" content="引入上月内容" placement="top">
                     <span @click.stop="getMonthTarget(row, rowIndex)" v-if="(row.source === 4 || row.source === 2) && (status === 0 || status === 30 ) && editStatus == 'edit'" class="program-tip">
                      <i class="icon-fuzhi"></i>
                    </span>
                  </el-tooltip>
                </div>
              </template>
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.currentMonthTarget"
                ></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="160"
              field="currentMonthFinishDate"
              title="本月目标完成时间"
              :edit-render="{ enabled: fromOtherAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-date-picker v-model="row.currentMonthFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
              <template #default="{ row }">{{ formatDate(row.currentMonthFinishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            <vxe-table-column
              min-width="80"
              field="weight"
              :controls="false"
              title="权重"
              :edit-render="{ enabled: weightAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-autocomplete @change="regWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch"></el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              field="isImportantWork"
              title="重点关注"
              :edit-render="{ name: 'ElSelect', enabled: fromOtherAuth, autofocus: '.el-input__inner' }"
            >
              <template #default="{row}">
                <span v-if="row.isImportantWork == 0">否</span>
                <span v-if="row.isImportantWork == 1">是</span>
              </template>
              <template #edit="scope">
                <el-select v-model="scope.row.isImportantWork" @change="$refs.month.updateStatus(scope)">
                  <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="model == 4 ? null : 100"
              field="completeStatus"
              title="完成情况"
              :edit-render="{ name: 'ElSelect', options: completeList, enabled: completeAuth, autofocus: '.el-input__inner' }"
            >
              <template #default="{row}">
                <!-- <span v-if="row.completeStatus === 0">计划</span> -->
                <span v-if="row.completeStatus == 10">未完成</span>
                <span v-if="row.completeStatus == 20">月目标完成</span>
                <!-- <span v-if="row.completeStatus == 20">已完成</span> -->
                <span v-if="row.completeStatus == 25">总目标完成</span>
                <span v-if="row.completeStatus == 30">延迟</span>
                <span v-if="row.completeStatus == 40">转移</span>
                <span v-if="row.completeStatus == 50">关闭</span>
              </template>
              <template #edit="scope">
                <el-select v-model="scope.row.completeStatus" @change="$refs.month.updateStatus(scope)">
                  <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" :width="model == 4 ? null : 250" field="reason" title="总结" :edit-render="{ enabled: completeAuth, autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" field="remark" title="备注" :edit-render="{ enabled: completeAuth || fromOtherAuth, autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.remark"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column fixed="right" class-name="status" min-width="160" field="status" title="提交状态">
              <template #default="{ row }">
                <el-tag v-if="row.status === 0" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 10" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 20" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 30" type="close" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 35" type="delay" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 40" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 50" type="close" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-popover
                  v-if="row.status === 30 || row.status === 50"
                  placement="top"
                  width="300"
                  popper-class="reason"
                  :visible-arrow="false"
                  trigger="hover"
                >
                  <div>
                    {{ row.approveReason || '无' }}
                  </div>
                  <span slot="reference" class="program-tip reason">
                    <i class="icon-hint"></i>
                  </span>
                </el-popover>
              </template>
            </vxe-table-column>
            <vxe-table-column field="" title="操作" fixed="right" min-width="180" class-name="operation">
              <template #default="scope">
                <div v-if="(scope.row.status === 0 || scope.row.status === 30 || scope.row.status === 100) && editStatus == 'edit'">
                  <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                    <i v-throttle class="icon-baocun" @click.stop="save(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="复制" placement="bottom">
                    <i v-throttle class="icon-copy" @click.stop="copyData(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.id" class="item" effect="dark" content="切换分类" placement="bottom">
                    <i class="icon-move" @click.stop="move(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
                <div v-if="(scope.row.status === 20 || scope.row.status === 50) && editStatus == 'edit' && status === 20">
                  <el-tooltip class="item" effect="dark" content="提交" placement="bottom">
                    <i class="icon-send" @click.stop="commitComplete(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
                <div v-if="scope.row.status === 35 && editStatus == 'approve'">
                  <el-tooltip class="item" effect="dark" content="通过" placement="bottom">
                    <i class="icon-definite" @click.stop="complete(scope.row, scope.rowIndex, 'access')"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="驳回" placement="bottom">
                    <i class="icon-overruled" @click.stop="complete(scope.row, scope.rowIndex, 'refuse')"></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
      <div v-show="currentTab === 1" class="search-and-content atb-flex atb-flex-column" id="normal">
        <div class="search">
          <el-form v-if="expandSearchStatus" :inline="true" :model="normalSearch" class="atb-input normal-form" @keyup.enter.native="getNormalList" @submit.native.prevent>
            <el-form-item class="flex-form-item" label="类别">
              <el-autocomplete v-model="normalSearch.WorkItemCategory" :fetch-suggestions="querySearch"></el-autocomplete>
            </el-form-item>
            <el-form-item class="flex-form-item" label="完成情况">
              <el-select clearable v-model="normalSearch.CompleteStatus" placeholder="完成情况">
                <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="关键字">
              <el-input v-model="normalSearch.KeyWord" placeholder="工作项目"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getNormalList">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input model">
              <el-form-item>
                <el-radio-group v-model="model" @change="changeModel">
                  <el-radio label="1">完整模式</el-radio>
                  <el-radio label="2">计划模式</el-radio>
                  <el-radio label="3">总结模式</el-radio>
                  <el-radio label="4">汇报模式</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="editStatus == 'edit' && status !== 10">
                <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-button :disabled="pending" type="primary" @click="copyPreviousMonthPlan">复制</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit'">
                <el-button type="primary" @click="submitHandle">提交</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' || editStatus==='manage'">
                <el-button type="import" plain @click="exportExcel">导出</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-upload ref="file" :http-request="uploadFile" :multiple="false" :show-file-list="false">
                  <el-button type="import" plain>导入</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && (status === 0 || status === 30)">
                <el-button type="downloadTemplate" plain @click="downloadTemplate">下载模板</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'approve'">
                <el-button :disabled="disabledApprove" type="primary" @click="showApprove = true">通过</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'approve'">
                <el-button :disabled="disabledApprove" type="refuse" @click="showCompleteApprove = true">驳回</el-button>
              </el-form-item>
               <el-form-item>
                <el-button type="downloadTemplate" plain @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus == 'edit' && status !== 10">
                <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                  <el-button type="import" plain class="menu-button">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="a">本月目标完成时间</el-dropdown-item>
                    <el-dropdown-item command="b">总目标完成时间</el-dropdown-item>
                    <el-dropdown-item command="c">完成情况</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
              <el-form-item v-if="editStatus==='manage'">
                <el-button type="downloadTemplate" plain @click="preciseExport">精确导出</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column normal">
          <div v-show="showCollapse" class="collapse" @click="collapse($refs.normal, normalColumn, 'normal')">
            <i :class="[isNormalCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
          </div>
          <vxe-table
            class="atb-table header-table edit-table border-table disable-ellipsis"
            border="full"
            height="100%"
            auto-resize
            resizable
            :data="normalTableData"
            :merge-cells="mergeNormal"
            :row-class-name="setNormalRowClass"
            :cell-class-name="setCellClass"
            ref="normal"
            :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
            @edit-closed="editNormalClose"
            @edit-actived="activeNormalRow"
            @cell-click="expandNormalRow"
            :edit-rules="validRules"
          >
            <vxe-table-column type="checkbox" width="40" align="center">
              <template #checkbox="scope">
                <template v-if="scope.rowIndex === 0">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <span>例行工作</span>
                      <i v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addNormal" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="(status === 0 || status === 30) && editStatus == 'edit'" @click="addNormal(scope.row)">新增</span>
                  </div>
                </template>
                <template v-else>
                  <span
                    v-if="status !== 10"
                    title="选择/取消"
                    :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']"
                    @click.stop="selectNormalSingle(scope.row)"
                  >
                    <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                    <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                    <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                  </span>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column width="40" title="源">
              <template #default="{row}">
                <div class="atb-flex atb-flex-items-center">
                  <i v-if="row.source === 1" class="icon-tubiao-99 source-icon add"></i>
                  <i v-else-if="row.source === 2" class="icon-tubiao-96 source-icon pre"></i>
                  <i v-else-if="row.source === 3" class="icon-tubiao-99 source-icon self"></i>
                  <i v-else-if="row.source === 4" class="icon-tubiao-95 source-icon year"></i>
                  <i v-else-if="row.source === 7" class="icon-zhuan source-icon zhuan"></i>
                  <i v-else-if="row.source === 8" class="icon-jiao source-icon jiao"></i>
                  <i v-else-if="row.source === 9" class="icon-todo-work source-icon todo"></i>
                  <i v-else></i>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
              <template #default="scope">
                <span>{{ scope.rowIndex }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="60"
              width="100"
              field="workItemCategory"
              title="类别"
              :edit-render="{ name: 'ElAutocomplete', enabled: categoryAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
              </template>
              <template #edit="{ row }">
                <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                  <template slot-scope="{ item }">
                    <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                      <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                    </el-tooltip>
                  </template>
                </el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="model == 4 ? null : 150"
              field="workItemContent"
              title="工作项目"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #edit="{ row }">
                <el-input type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.workItemContent"></el-input>
              </template>
              <template #default="scope">
                <template>
                  <div class="atb-flex atb-flex-items-center" @contextmenu.prevent="popupHistory(scope.row)">
                    <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}
                    </div>
                    <el-popover
                      placement="right"
                      v-if="scope.row.isPublished == 1"
                      width="416"
                      height="200"
                      popper-class="history"
                      trigger="hover"
                      @show="getAddWork(scope.row)"
                      :visible-arrow="false"
                    >
                      <el-checkbox-group v-model="checkList" class="program-check">
                        <li class="atb-flex" v-for="item in programData" :key="item.id">
                          <el-checkbox :label="item.id">
                            <span>{{ item.resWkName }}</span>
                          </el-checkbox>
                          <div>
                            <p class="desc">{{ item.workItemContent }}</p>
                            <p class="date">{{ $formatTime(item.currentMonthFinishDate, 'yyyy-MM-dd') }}</p>
                          </div>
                        </li>
                      </el-checkbox-group>
                      <div class="footer">
                        <el-checkbox class="select-all-program" @change="checkAll" v-model="selectAllProgram">全选</el-checkbox>
                        <el-button class="atb-dialog-confirm copy" type="primary" @click="copyProgram">复制</el-button>
                      </div>
                      <span slot="reference" class="program-tip">
                        <i class="icon-synchronize"></i>
                      </span>
                    </el-popover>
                  </div>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" field="resWkName" title="责任人" :edit-render="{ enabled: false }">
              <template #edit="{ row }">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="row.resWkName"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="80"
              width="250"
              field="wholeTarget"
              title="总目标"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
              </template>
              <template #edit="{ row }">
                <el-input type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.wholeTarget"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="150"
              field="finishDate"
              title="总目标完成时间"
              :edit-render="{ enabled: normalAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
              <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            <vxe-table-column
              min-width="160"
              :width="model == 4 ? null : 250"
              field="currentMonthTarget"
              title="本月需达到的目标"
              :edit-render="{ enabled: fromOtherAuth, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row, rowIndex}">
                <div class="atb-flex atb-flex-items-center">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.currentMonthTarget }}
                  </div>
                  <el-tooltip class="item" effect="dark" content="引入上月内容" placement="top">
                     <span @click.stop="getMonthTarget(row, rowIndex)" v-if="(row.source === 4 || row.source === 2) && (status === 0 || status === 30 ) && editStatus == 'edit'" class="program-tip">
                      <i class="icon-fuzhi"></i>
                    </span>
                  </el-tooltip>
                </div>
              </template>
              <template #edit="{ row }">
                <el-input type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.currentMonthTarget"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="160"
              field="currentMonthFinishDate"
              title="本月目标完成时间"
              :edit-render="{ enabled: fromOtherAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-date-picker v-model="row.currentMonthFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
              <template #default="{ row }">{{ formatDate(row.currentMonthFinishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            <vxe-table-column
              min-width="80"
              field="weight"
              :controls="false"
              title="权重"
              :edit-render="{ enabled: weightAuth, autofocus: '.el-input__inner' }"
            >
              <template #edit="{ row }">
                <el-autocomplete @change="regWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch"></el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              field="isImportantWork"
              title="重点关注"
              :edit-render="{ name: 'ElSelect', enabled: fromOtherAuth, autofocus: '.el-input__inner' }"
            >
              <template #default="{row}">
                <span v-if="row.isImportantWork == 0">否</span>
                <span v-if="row.isImportantWork == 1">是</span>
              </template>
              <template #edit="scope">
                <el-select v-model="scope.row.isImportantWork" @change="$refs.month.updateStatus(scope)">
                  <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="model == 4 ? null : 100"
              field="completeStatus"
              title="完成情况"
              :edit-render="{ name: 'ElSelect', options: completeList, enabled: completeAuth, autofocus: '.el-input__inner' }"
            >
              <template #default="{row}">
                <!-- <span v-if="row.completeStatus === 0">计划</span> -->
                <span v-if="row.completeStatus == 10">未完成</span>
                <!-- <span v-if="row.completeStatus == 20">已完成</span> -->
                <span v-if="row.completeStatus == 20">月目标完成</span>
                <span v-if="row.completeStatus == 25">总目标完成</span>
                <span v-if="row.completeStatus == 30">延迟</span>
                <span v-if="row.completeStatus == 40">转移</span>
                <span v-if="row.completeStatus == 50">关闭</span>
              </template>
              <template #edit="scope">
                <el-select v-model="scope.row.completeStatus" @change="$refs.month.updateStatus(scope)">
                  <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" :width="model == 4 ? null : 250" field="reason" title="总结" :edit-render="{ enabled: completeAuth, autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="80" field="remark" title="备注" :edit-render="{ enabled: completeAuth || fromOtherAuth, autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.remark"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column fixed="right" min-width="160" field="status" title="提交状态">
              <template #default="{ row }">
                <el-tag v-if="row.status === 0" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 10" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 20" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 30" type="close" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 35" type="delay" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 40" type="complete" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-tag v-if="row.status === 50" type="close" effect="dark">
                  {{ getStatusName(row.status) }}
                </el-tag>
                <el-popover
                  v-if="row.status === 30 || row.status === 50"
                  placement="top"
                  width="300"
                  popper-class="reason"
                  trigger="hover"
                  @show="getAddWork(scope.row)"
                  :visible-arrow="false"
                >
                  <div>
                    {{ row.approveReason || '无' }}
                  </div>
                  <span slot="reference" class="program-tip reason">
                    <i class="icon-hint"></i>
                  </span>
                </el-popover>
              </template>
            </vxe-table-column>
            <vxe-table-column field="" title="操作" fixed="right" min-width="180" class-name="operation">
              <template #default="scope">
                <div v-if="(scope.row.status === 0 || scope.row.status === 30 || scope.row.status === 100) && editStatus == 'edit'">
                  <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                    <i v-throttle class="icon-baocun" @click.stop="saveNormal(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="复制" placement="bottom">
                    <i v-throttle class="icon-copy" @click.stop="copyNormal(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <i v-throttle class="icon-close delete" @click.stop="deleteNormal(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.id" class="item" effect="dark" content="切换分类" placement="bottom">
                    <i class="icon-move" @click.stop="move(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
                <div v-if="(scope.row.status === 20 || scope.row.status === 50) && editStatus == 'edit' && status === 20">
                  <el-tooltip class="item" effect="dark" content="提交" placement="bottom">
                    <i class="icon-send" @click.stop="commitComplete(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
                <div v-if="scope.row.status === 35 && editStatus == 'approve'">
                  <el-tooltip class="item" effect="dark" content="确定" placement="bottom">
                    <i class="icon-definite" @click.stop="complete(scope.row, scope.rowIndex, 'access')"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="驳回" placement="bottom">
                    <i class="icon-overruled" @click.stop="complete(scope.row, scope.rowIndex, 'refuse')"></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
    </div>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in classifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="历史工作项内容"
      :visible.sync="showHistory"
      width="1200px"
      custom-class="history"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <vxe-table class="atb-table header-table edit-table disable-ellipsis" border="full" height="100%" auto-resize resizable :data="historyData" ref="popup">
          <vxe-table-column type="seq" min-width="50" title="NO." align="center"></vxe-table-column>
          <vxe-table-column field="title" min-width="120" title="标题" align="center"></vxe-table-column>
          <vxe-table-column min-width="130" field="workClassify" title="工作分类">
            <template #default="{row}">
              <span v-if="row.workClassify == 0">KPI工作</span>
              <span v-if="row.workClassify == 10">例行工作</span>
              <span v-if="row.workClassify == 20">问题及创新工作</span>
              <span v-if="row.workClassify == 30">其他新增工作</span>
              <span v-if="row.workClassify == 40">费效管理</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="200" field="workItemContent" title="工作项目"></vxe-table-column>
          <vxe-table-column min-width="200" field="wholeTarget" title="总目标"></vxe-table-column>
          <vxe-table-column min-width="200" field="currentMonthTarget" title="本月需达到目标"></vxe-table-column>
          <vxe-table-column min-width="100" field="completeStatus" title="完成情况">
            <template #default="{row}">
              <!-- <span v-if="row.completeStatus === 0">计划</span> -->
              <span v-if="row.completeStatus == 10">未完成</span>
              <span v-if="row.completeStatus == 20">月目标已完成</span>
              <span v-if="row.completeStatus == 25">总目标完成</span>
              <span v-if="row.completeStatus == 30">延迟</span>
              <span v-if="row.completeStatus == 40">转移</span>
              <span v-if="row.completeStatus == 50">关闭</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="200" field="reason" title="总结"></vxe-table-column>
        </vxe-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHistory = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="审批通过原因可不填" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showCompleteApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="审批驳回原因必须填写" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCompleteApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" class="submit-limit-tip" :visible.sync="showSubmitTip" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <i class="submit-limit-icon el-icon-question"></i>
        <h2 class="submit-limit-title">是否确定提交月计划？</h2>
        <div class="submit-tip-wrap" style="display: block;">
          <span class="submit-tip-label">您的</span>
          <span class="submit-tip-content">
            <span class="submit-tip-item" v-for="item, index in submitLimitMsg" :key="index">
              <span>{{ item.classifyName }}</span><span>需≥</span><span>{{ item.minLimit }}条</span>
              <span v-if="index < submitLimitMsg.length - 1">；</span>
              <span v-else>。</span>
            </span>
          </span>
        </div>
        <div class="submit-tip-text">需您补充完整或在总结时至<span class="submit-tip-link" @click="toToDoWork">“个人工作台-工作待办”</span>处将工作项目补充完整。</div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmitTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" class="submit-limit-tip submit-summary" :visible.sync="showSubmitSummaryTip" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <i class="submit-limit-icon el-icon-warning"></i>
        <h2 class="submit-limit-title">您的月总结暂不能提交！</h2>
        <div class="submit-tip-wrap">
          <span class="submit-tip-label">您的</span>
          <span class="submit-tip-content">
            <span class="submit-tip-item" v-for="(item, index) in submitLimitMsg" :key="index">
              <span>{{ item.classifyName }}</span><span>需≥</span><span>{{ item.minLimit }}条</span>
              <span v-if="index < submitLimitMsg.length - 1">；</span>
              <span v-else>。</span>
            </span>
          </span>
        </div>
        <div class="submit-tip-text">请至<span class="submit-tip-link" @click="toToDoWork">“个人工作台-工作待办”</span>处将工作项目补充完整后即可进行总结提交！</div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-confirm" type="primary" @click="showSubmitSummaryTip = false">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </div>
    </el-dialog>
    <context-menu :data="tableColumn" :selector="`#all .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <context-menu :data="tableColumn" :selector="`#normal .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :command="dialogContent.command" :completeList="completeList" :selectData="selecterData" :editData="editData" @submitSuccess="copyLast"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
export default {
  name: 'index',
  inject: ['reload'],
  mixins: [routeMixin],
  components: {
    addSync: () => import('./addSync.vue'),
    batchEdit: () => import('./batchEdit.vue'),
    export: () => import('./export.vue'),
  },
  data() {
    const workItemContent = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('工作项目必填');
      }
    };
    const wholeTarget = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('总目标必填');
      }
    };
    const finishDate = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('总目标完成时间必填');
      }
    };
    const currentMonthTarget = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('本月需达到的目标必填');
      }
    };
    const currentMonthFinishDate = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('本月目标完成时间必填');
      }
    };
    const weight = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('权重必填');
      }
    };
    const completeStatus = ({cellValue, row}) => {
      if (!cellValue && (row.status === 20 || row.status === 50) && this.status === 20) {
        return new Error('完成情况必填')
      }
    }
    const reason = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 20 || row.status === 50) && this.status === 20) {
        return new Error('总结必填');
      }
    };
    return {
      validRules: {
        workItemContent: [{ required: true, validator: workItemContent, message: '工作项目必填' }],
        wholeTarget: [{ required: true, validator: wholeTarget, message: '总目标必填' }],
        weight: [{ required: true, validator: weight, message: '权重必填' }],
        currentMonthTarget: [{ required: true, validator: currentMonthTarget, message: '本月需达到的目标必填' }],
        finishDate: [{ required: true, validator: finishDate, message: '总目标完成时间必填' }],
        currentMonthFinishDate: [{ required: true, validator: currentMonthFinishDate, message: '本月目标完成时间必填' }],
        reason: [{ validator: reason, message: '总结必填' }],
        completeStatus: [{ validator: completeStatus,message:'完成情况必填' }],
      },
      workId: '',
      childIds: [],
      activeName: 'second',
      currentTab: 0,
      showHandle: false,
      showHistory: false,
      showAddWork: false,
      showApprove: false,
      showCompleteApprove: false,
      showSubmit: false,
      handleDelete: true,
      tabList: [
        {
          label: 'KPI、问题及创新工作',
          id: 0,
        },
        {
          label: '例行工作',
          id: 1,
        },
      ],
      searchParam: {
        WorkItemCategory: null,
        WorkClassify: null,
        KeyWord: null,
        CompleteStatus: null,
      },

      normalSearch: {
        WorkItemCategory: null,
        WorkClassify: 10,
        KeyWord: null,
        CompleteStatus: null,
      },
      //列编辑权限控制
      categoryAuth: true, //类别编辑权限
      normalAuth: true, //普通编辑权限
      completeAuth: true, //完成情况权限 ---> 完成情况 原因
      fromOtherAuth: true, // 其他来源权限 ---> 本月需达到目标、本月目标完成时间、是否重点工作、完成情况、原因
      weightAuth: true, //权重权限 ---> 权重
      remarkAuth: true, // 备注编辑权限
      mergeCells: [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ],
      mergeNormal: [{ row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength }],
      result: {},
      kpi: [],
      normal: [],
      budget: [],
      create: [],
      other: [],
      record: {
        workId: '',
        workClassify: 0,
        workItemNo: '',
        workItemCategory: '',
        workItemContent: '',
        resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
        resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
        wholeTarget: '',
        finishDate: '',
        currentMonthTarget: '',
        currentMonthFinishDate: '',
        weight: 1,
        isImportantWork: 0,
        completeStatus: null,
        reason: '',
        creatorId: sessionStorage.getItem('LOGIN_NAME'),
        status: 100,
        remark: '',
        creationTimeSapn: ''
      },
      classifyList: [
        { label: 'KPI工作', value: 0 },
        { label: '费效管理', value: 40 },
        { label: '例行工作', value: 10 },
        { label: '问题及创新工作', value: 20 },
        { label: '其他新增工作', value: 30 },
      ],
      categoryList: [],
      completeList: [
        // { label: '计划', value: 0 },
        { label: '未完成', value: 10 },
        // { label: '已完成', value: 20 },
        { label: '月目标完成', value: 20 },
        { label: '总目标完成', value: 25 },
        { label: '延迟', value: 30 },
        // {label: '转移', value: 40},
        { label: '关闭', value: 50 },
      ],
      statusList: [],
      importantList: [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
      programList: [{ value: 'A2000plus' }, { value: 'A1000plus' }, { value: '远程项目' }],
      weightList: [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }],
      unHandleList: [],
      handledList: [],
      allChecked: false,
      programData: [],
      checkList: [],
      selectAllProgram: false,
      isChecked: false,
      status: 0,
      detail: {},
      idList: [],
      timer: null,
      classify: '',
      nowClassify: {},
      row: {},
      rowIndex: 0,
      normalRow: {},
      normalRowIndex: 0,
      tableColumn: [],
      normalColumn: [],
      historyData: [],
      expandKpiStatus: true,
      expandBudgetStatus: true,
      expandCreateStatus: true,
      expandOtherStatus: true,
      editStatus: 'edit',
      cloneTableData: [],
      cloneNormalTableData: [],
      model: '1',
      approveReason: '',
      approveRow: null,
      that: this,
      saveStatus: '',
      timeoutSave: '',
      timeoutAutoSave: '',
      timeoutSaveNormal: '',
      timeoutAutoSaveNormal: '',
      cloneKpi: [],
      cloneBudget: [],
      cloneCreate: [],
      cloneOther: [],
      disabledApprove: false,
      isCollapse: false,
      isNormalCollapse: false,
      showCollapse: false,
      subRules: {
        workItemCategory: {
          require: true,
          message: '工作类别',
        },
        workItemContent: {
          require: true,
          message: '请填写工作项目',
        },
        wholeTarget: {
          require: true,
          message: '请填写总目标',
        },
        finishDate: '',
        currentMonthTarget: '',
        currentMonthFinishDate: '',
        weight: 1,
        isImportantWork: 0,
        completeStatus: 0,
        reason: '',
      },
      pending: false,
      dialogContent: {},
      editData: {},
      downloadUrl: process.env.VUE_APP_PUBLICPATH + 'files/月计划导入模板.xlsx',
      autoSaving: false, //是否在自动保存中
      isPreventSave: false, //是否阻止了自动保存,
      expandSearchStatus: false,
      expandRowAllFlag: false,
      selecterData: [],

      showSubmitTip: false, // 计划提交弹窗提示
      showSubmitSummaryTip: false, // 总结提交弹窗提示
      submitLimitMsg: [], // 总结提交时，不满足条件的工作分类
      minLimits: [],
      noMinLimits: [],
    };
  },
  computed: {
    kpiLength() {
      //kpi数据长度 动态增加数据使用
      return this.kpi.length;
    },
    budgetLength() {
      return this.budget.length;
    },
    normalLength() {
      return this.normal.length;
    },
    createLength() {
      return this.create.length;
    },
    otherLength() {
      return this.other.length;
    },
    tableData() {
      return [{}, ...this.kpi, {}, ...this.budget, {}, ...this.create, {}, ...this.other];
    },
    tableColumnLength() {
      return this.tableColumn.filter((val) => val.visible !== false).length;
    },
    normalColumnLength() {
      return this.normalColumn.filter((val) => val.visible !== false).length;
    },
    normalTableData() {
      return [{}, ...this.normal];
    },
  },
  created() {
    this.workId = this.$route.query.id || '';
    this.status = Number(this.$route.query.status) || 0;
    this.record.workId = this.workId;
    this.childIds = this.$route.query.childIds || [];
    this.msgId = this.$route.query.msgId || null;
    this.editStatus = this.$route.query.editStatus || '';
    this.getWorkItemStatus().then(() => {
      this.getList();
    });
    // this.getNormalList();
    this.getCategory();
    this.getMinLimit();
    this.getNoMinLimitByDept();
  },
  mounted() {
    // document.addEventListener('keydown', this.saveContent);
    this.$nextTick(() => {
      this.tableColumn = this.$refs.month.getColumns();
      this.normalColumn = this.$refs.normal.getColumns();
      if(localStorage.getItem("month_table_herder") && this.editStatus === "edit" && this.model == "1"){
        let cache = JSON.parse(localStorage.getItem("month_table_herder"));
        this.tableColumn.forEach(v => {
          cache.forEach(t => {
            if (v.title == t.title){
              v.visible = t.visible;
            }
          })
        })
        this.normalColumn.forEach(v => {
          cache.forEach(t => {
            if (v.title == t.title){
              v.visible = t.visible;
            }
          })
        })
        this.$refs.month && this.$refs.month.refreshColumn();
        this.$refs.normal && this.$refs.normal.refreshColumn();
      }else {
        if(this.editStatus === "edit") {
          localStorage.setItem("month_table_herder", JSON.stringify(this.tableColumn));
        }else {
          if (!this.editStatus) {
            let val = this.tableColumn.find((val) => val.title == '操作');
            val.visible = false;
            this.$refs.month && this.$refs.month.refreshColumn();

            let val1 = this.normalColumn.find((val) => val.title == '操作');
            val1.visible = false;
            this.$refs.normal && this.$refs.normal.refreshColumn();
          }
        }
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    // document.removeEventListener('keydown', this.saveContent)
  },
  methods: {
    getMinLimit() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthClassifyMINLimit' }).then((res) => {
        const minLimits = [];
        const data = (res.data && res.data.rows) || [];
        data.forEach(item => {
          const classify = this.classifyList.find(c => c.value == item.itemKey);
          minLimits.push({
            workClassify: classify.value,
            minLimit: item.itemValue,
            classifyName: classify.label,
            sort: item.sort
          })
        })
        minLimits.sort((a, b) => a.sort - b.sort);

        this.minLimits = minLimits;
      });
    },
    getNoMinLimitByDept() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'NoMonthClassifyMINLimit' }).then((res) => {
        const data = (res.data && res.data.rows) || [];
        this.noMinLimits = data;
      });
    },
    async getMonthTarget(row) {
      if (row.currentMonthTarget) {
        this.$confirm('这将覆盖“本月需达到的目标”里的内容，确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(async() => {
          const res = await new Promise(resolve => {
            this.$ajax.get(this.$api.month.MonthWorkDetail.pre, {id: row.id}).then(res => {
              resolve(res.data);
            })
          });
          if (row.workClassify == 10) {
            this.normalTableData.forEach(val => {
              if (val.id === row.id) {
                val.currentMonthTarget = res.currentMonthTarget;
              }
            });
            this.$ajax.post(this.$api.month.MonthWorkDetail.detail, this.normalTableData.find(val => val.id === row.id)).then(() => {
              
            });
          }else {
            this.tableData.forEach(val => {
              if (val.id === row.id) {
                val.currentMonthTarget = res.currentMonthTarget;
              }
            });
            this.$ajax.post(this.$api.month.MonthWorkDetail.detail, this.tableData.find(val => val.id === row.id)).then(() => {
              
            });
          }
        });
      }else {
        const res = await new Promise(resolve => {
            this.$ajax.get(this.$api.month.MonthWorkDetail.pre, {id: row.id}).then(res => {
              resolve(res.data);
            })
          });
          if (row.workClassify == 10) {
            this.normalTableData.forEach(val => {
              if (val.id === row.id) {
                val.currentMonthTarget = res.currentMonthTarget;
              }
            });
            this.$ajax.post(this.$api.month.MonthWorkDetail.detail, this.normalTableData.find(val => val.id === row.id)).then(() => {});
          }else {
            this.tableData.forEach(val => {
              if (val.id === row.id) {
                val.currentMonthTarget = res.currentMonthTarget;
              }
            });
            this.$ajax.post(this.$api.month.MonthWorkDetail.detail, this.tableData.find(val => val.id === row.id)).then(() => {});
          }
      }
    },
    handleCommand(command) {
      this.getSelect();
      if (this.selecterData.length == 0) {
        this.$message.error('请先选择要修改的工作项');
        return false;
      }
      this.dialogContent = {
        title: '批量操作',
        componentName: 'batchEdit',
        width: '450px',
        command: command
      };
      this.editData.workId = this.workId;
      this.$refs.addSyncDialog.show();
      
    },
    expandSearch(){
      this.expandSearchStatus = !this.expandSearchStatus;
    },
    copyLast() {
      this.expandAll();
      this.getList();
    },
    downloadTemplate() {
      window.location.href = this.downloadUrl;
    },
    uploadFile({ file }) {
      const params = new FormData();
      params.append('workId', this.workId);
      params.append('excelfile', file);
      this.$ajax.post(this.$api.month.MonthWorkDetail.Import, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
        if (res.code === 0) {
          this.expandAll();
          this.$message.success('上传成功');
          this.getList();
        }
      });
    },
    copyPreviousMonthPlan() {
      this.dialogContent = {
        title: '复制月计划',
        componentName: 'addSync',
        width: "950px"
      };
      this.editData.workId = this.workId;
      this.$refs.addSyncDialog.show();
    },
    getStatusName(val) {
      const obj = this.statusList.find((t) => t.itemValue == val);
      return obj ? obj.itemDesc : '';
    },
    async getWorkItemStatus() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'WorkItemStatus' }).then((res) => {
        this.statusList = (res.data && res.data.rows) || [];
      });
    },
    regWeight(row) {
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    collapse(el, column, table) {
      if (table === 'kpi') {
        this.isCollapse = !this.isCollapse;
        if (this.isCollapse) {
          column.forEach((val) => {
            if (val.title == '操作' || val.title == '提交状态') {
              val.visible = false;
            }
          });
          el && el.refreshColumn();
          this.setPosition('reset', table);
        } else {
          column
            .filter((val) => val.title == '操作' || val.title == '提交状态')
            .forEach((val) => {
              val.visible = true;
            });
          el && el.refreshColumn();
          setTimeout(() => {
            this.setPosition(null, table);
            // this.observerClass(table);
          }, 50);
        }
      } else {
        this.isNormalCollapse = !this.isNormalCollapse;
        if (this.isNormalCollapse) {
          column.forEach((val) => {
            if (val.title == '操作' || val.title == '提交状态') {
              val.visible = false;
            }
          });
          el && el.refreshColumn();
          this.setPosition('reset', table);
        } else {
          column
            .filter((val) => val.title == '操作' || val.title == '提交状态')
            .forEach((val) => {
              val.visible = true;
            });
          el && el.refreshColumn();
          setTimeout(() => {
            this.setPosition(null, table);
            // this.observerClass(table);
          }, 50);
        }
      }
    },
    setPosition(reset, table) {
      this.showCollapse = true;
      let left, height;
      if (!document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0] && this.currentTab == 0) {
        this.showCollapse = false;
        return false;
      }
      if (!reset && document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth === 0 && this.currentTab == 0) {
        this.showCollapse = false;
        return false;
      }
      if (!document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1] && this.currentTab == 1) {
        this.showCollapse = false;
        return false;
      }
      if (!reset && document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1].offsetWidth === 0 && this.currentTab == 1) {
        this.showCollapse = false;
        return false;
      }
      if (reset) {
        if (table === 'kpi') {
          document.getElementsByClassName('collapse')[0].style.right = 0;
        } else {
          document.getElementsByClassName('collapse')[1].style.right = 0;
        }
      } else {
        if (table === 'kpi') {
          left = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
          height = document.getElementsByClassName('table-content')[0].offsetHeight;
          document.getElementsByClassName('collapse')[0].style.top = height / 2 - 15 + 'px';
          document.getElementsByClassName('collapse')[0].style.right = left + 'px';
          // left = document.getElementsByClassName("vxe-table--main-wrapper")[0].getElementsByClassName("col--fixed")[0].offsetWidth +
          //     document.getElementsByClassName("vxe-table--main-wrapper")[0].getElementsByClassName("col--fixed")[1].offsetWidth;
        } else {
          left = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1].offsetWidth;
          height = document.getElementsByClassName('table-content')[1].offsetHeight;
          document.getElementsByClassName('collapse')[1].style.top = height / 2 - 15 + 'px';
          document.getElementsByClassName('collapse')[1].style.right = left + 'px';
          //   height = document.getElementsByClassName("table-content")[1].offsetHeight;
          //   left = document.getElementsByClassName("vxe-table--main-wrapper")[1].getElementsByClassName("col--fixed")[0].offsetWidth +
          //       document.getElementsByClassName("vxe-table--main-wrapper")[1].getElementsByClassName("col--fixed")[1].offsetWidth;
        }
        //判断有无滚动条
        // const client = document.getElementsByClassName("vxe-table--body-wrapper")[0].clientWidth;
        // const offset = document.getElementsByClassName("vxe-table--body-wrapper")[0].offsetWidth;
        // if (client === offset) {
        //   document.getElementsByClassName("collapse")[0].style.right = left + "px";
        //   document.getElementsByClassName("collapse")[1].style.right = left + "px";
        // }else {
        //   document.getElementsByClassName("collapse")[0].style.right = left + "px";
        //   document.getElementsByClassName("collapse")[1].style.right = left + "px";
        // }
        // document.getElementsByClassName("collapse")[0].style.top = (height / 2 - 15)  + "px";
        // document.getElementsByClassName("collapse")[1].style.top = (height / 2 - 15)  + "px";
      }
    },
    observerClass(table) {
      let targetNode;
      // 选择需要观察变动的节点
      if (table === 'kpi') {
        targetNode = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0];
      } else {
        targetNode = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1];
      }
      // 观察器的配置（需要观察什么变动）
      const config = { attributes: true, attributeFilter: ['class', 'style'] };
      // 当观察到变动时执行的回调函数
      const callback = function(mutationsList) {
        // Use traditional 'for loops' for IE 11
        const classList = mutationsList[0].target.classList;
        // console.log(classList);
        if (classList.length == 1) {
          if (table === 'kpi') {
            document.getElementsByClassName('collapse')[0].style.display = 'none';
          } else {
            document.getElementsByClassName('collapse')[1].style.display = 'none';
          }
        } else {
          if (table === 'kpi') {
            document.getElementsByClassName('collapse')[0].style.display = 'block';
          } else {
            document.getElementsByClassName('collapse')[1].style.display = 'block';
          }
        }
      };
      // 创建一个观察器实例并传入回调函数
      const observer = new MutationObserver(callback);
      // 以上述配置开始观察目标节点
      observer.observe(targetNode, config);
      // 之后，可停止观察
      // observer.disconnect();
    },
    approveText(e) {
      this.approveReason = e;
    },
    exportExcel() {
      let param = Object.assign({ WorkId: this.workId });
      this.$ajax.get(this.$api.month.MonthWorkDetail.export, param, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result; //内容就在这里
            let json = JSON.parse(content);
            this.$message.error(json.message);
          };
          reader.readAsText(res.data);
        } else {
          const filename = Object.keys(this.detail).length ? this.detail.title + '详情' + '(' + this.detail.resWkName + ')' : '月计划详情';
          const filetype = 'xlsx';
          let data = res.data;
          let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + '.' + filetype;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    preciseExport() {
      this.dialogContent = {
        title: '精确导出',
        componentName: 'export',
        width: '950px',
      };
      this.editData.workId = this.workId;
      this.$refs.addSyncDialog.show();
    },
    expandRowAll() {
      if (this.expandRowAllFlag) {
        this.tableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = false;
          }
        });
        this.normalTableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = false;
          }
        });
     }else {
        this.tableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = true;
          }
        });
        this.normalTableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = true;
          }
        });
      }
      this.expandRowAllFlag = !this.expandRowAllFlag;
      this.$refs.month.updateData(this.tableData);
      this.$refs.normal.updateData(this.normalTableData);

      this.$nextTick(() => {
        if (this.$refs.month) {
          let scrollInfo = this.$refs.month.getScroll();
          this.$refs.month.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
        }
        if (this.$refs.normal) {
          let scrollInfo = this.$refs.normal.getScroll();
          this.$refs.normal.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
        }
      });
    },
    expandRow({ row, rowIndex }) {
      if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus == 'approve')) {
        if (
          row.source === 1 ||
          row.source === 2 ||
          row.source === 3 ||
          row.source === 4 ||
          this.editStatus == 'approve' ||
          row.source === 5 ||
          this.editStatus == '' ||
          row.source === 7 ||
          row.source === 8 ||
          row.source === 9
        ) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
          this.$refs.month.updateData(this.tableData);
        }
      } else {
        if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.month.updateData(this.tableData);
      }
    },
    expandNormalRow({ row, rowIndex }) {
      if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus == 'approve')) {
        if (
          row.source === 1 ||
          row.source === 2 ||
          row.source === 3 ||
          row.source === 4 ||
          this.editStatus == 'approve' ||
          row.source === 5 ||
          this.editStatus == '' ||
          row.source === 7 ||
          row.source === 8 ||
          row.source === 9
        ) {
          if(this.$getRowExpandFlag()) this.normalTableData[rowIndex].expandRowFlag = !this.normalTableData[rowIndex].expandRowFlag;
          this.$refs.normal.updateData(this.normalTableData);
        }
      } else {
        if(this.$getRowExpandFlag()) this.normalTableData[rowIndex].expandRowFlag = !this.normalTableData[rowIndex].expandRowFlag;
        this.$refs.normal.updateData(this.normalTableData);
      }
    },
    // 列隐藏展示切换
    columnHideToggle(d) {
      let val = this.tableColumn.find((row) => row.title == d.title);
      let val2 = this.normalColumn.find((row) => row.title == d.title);
      if (val && val2) {
        val.visible = !val.visible;
        val2.visible = !val2.visible;
        this.$refs.month && this.$refs.month.refreshColumn();
        this.$refs.normal && this.$refs.normal.refreshColumn();
        if(this.editStatus === "edit" && this.model == "1") {
          localStorage.setItem("month_table_herder", JSON.stringify(this.tableColumn));
        }
        setTimeout(() => {
          this.setPosition(null, 'kpi');
          this.setPosition(null, 'normal');
        }, 50);
      }
    },
    saveContent(e) {
      let key = window.event.keyCode ? window.event.keyCode : window.event.which;
      if (key === 83 && e.ctrlKey) {
        e.preventDefault();
        this.saveAll();
      }
    },
    getCurrent(item) {
      this.currentTab = item.data.id;
      if (this.currentTab === 1) {
        // this.getNormalList();
      }
      this.changeModel(this.model);
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data;
        this.categoryList = this.filterCategory(item);
      });
    },
    getList(search) {
      let param = Object.assign({ WorkId: this.workId, WorkItemIds: this.childIds }, this.searchParam, this.page);
      return this.$ajax.get(this.$api.month.MonthWorkDetail.list, param).then((res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.detailDtoList;
        this.filterTableData(result);
        if (this.editStatus === 'approve') {
          this.disabledApprove = true;
          result.forEach((val) => {
            if (val.status !== 40 && val.status !== 50) {
              //有未审批就可以审批
              this.disabledApprove = false;
            }
          });
        }
        if (
          this.kpiLength === 0 &&
          this.budgetLength === 0 &&
          this.createLength === 0 &&
          this.otherLength === 0 &&
          (this.editStatus === 'approve' || this.editStatus == '') &&
          !search && this.normalLength !== 0
        ) {
          this.currentTab = 1;
        }
        this.detail = res.data.monthWorkDto;
        this.record.currentMonthFinishDate = this.$monthLast(this.detail.year, this.detail.month < 10 ? ('0' + this.detail.month) : this.detail.month);
        this.record.finishDate = this.$monthLast(this.detail.year, this.detail.month < 10 ? ('0' + this.detail.month) : this.detail.month);
        this.status = this.detail.status;
        //获取右侧第二列的位置信息
        setTimeout(() => {
          this.setPosition(null, 'kpi');
          // this.observerClass("kpi");
        }, 50);
        this.setMerge();
        this.setNormalMerge();
        if (result.length === 0) {
          this.tableData = [{}, {}, {}, {}];
        } else {
          this.tableData.forEach((val) => {
            val.expandRowFlag = false;
          });
        }
      });
    },
    getNormalList() {
      let param = Object.assign({ WorkId: this.workId, WorkItemIds: this.childIds }, this.normalSearch);
      this.$ajax.get(this.$api.month.MonthWorkDetail.list, param).then((res) => {
        this.normal = res.data.detailDtoList;
        this.$nextTick(() => {
          this.mergeNormal = [{ row: 0, col: 0, rowspan: 1, colspan: this.normalColumnLength }];
        });
        setTimeout(() => {
          this.setPosition(null, 'normal');
          // this.observerClass("normal");
        }, 50);
        this.setNormalMerge();
        this.normal.forEach((val) => {
          val.expandRowFlag = false;
        });
      });
    },
    filterTableData(tableData) {
      this.kpi = tableData.filter((val) => val.workClassify == 0);
      this.normal = tableData.filter((val) => val.workClassify == 10);
      this.budget = tableData.filter((val) => val.workClassify == 40);
      this.create = tableData.filter((val) => val.workClassify == 20);
      this.other = tableData.filter((val) => val.workClassify == 30);
    },
    getAllTableData() {
      //获取所有工作项的数据
      let relResult = [];
      if (this.cloneKpi.length) {
        relResult = relResult.concat(this.cloneKpi);
      } else {
        relResult = relResult.concat(this.kpi);
      }
      if (this.cloneBudget.length) {
        relResult = relResult.concat(this.cloneBudget);
      } else {
        relResult = relResult.concat(this.budget);
      }
      if (this.cloneCreate.length) {
        relResult = relResult.concat(this.cloneCreate);
      } else {
        relResult = relResult.concat(this.create);
      }
      if (this.cloneOther.length) {
        relResult = relResult.concat(this.cloneOther);
      } else {
        relResult = relResult.concat(this.other);
      }
      return [...relResult, ...this.normal];
    },
    // selectAllEvent({records}) {
    //   let data = records.filter(val => val.workId !== undefined);
    //   this.idList = data.map(val => {
    //     const {id} = val;
    //     return {id: id, workId: this.workId};
    //   });
    // },
    // handledSelectChange({records}) {
    //   this.idList  = records.map(val => {
    //     const {id} = val;
    //     return {id: id, workId: this.workId};
    //   });
    //   console.log(this.idList);
    // },
    selectSingle(row) {
      this.$refs.month.toggleCheckboxRow(row);
    },
    selectNormalSingle(row) {
      this.$refs.normal.toggleCheckboxRow(row);
    },
    async addKpi() {
      if (!this.expandKpiStatus) {
        this.expandKpiStatus = true;
        this.kpi = _.cloneDeep(this.cloneKpi);
        this.cloneKpi = [];
      }
      if (this.kpiLength >= this.$config.workItemLength.month.kpi) {
        this.$message.error(`最多可添加${this.$config.workItemLength.month.kpi}条数据`);
        return false;
      }
      const $table = this.$refs.month;
      let kpiItem = _.cloneDeep(this.record);
      kpiItem.creationTimeSapn = new Date().getTime();
      this.kpi.push(kpiItem);
      await $table.setActiveRow(this.tableData[this.kpiLength]);
    },
    async addNormal() {
      if (this.normalLength >= this.$config.workItemLength.month.normal) {
        this.$message.error(`最多可添加${this.$config.workItemLength.month.normal}条数据`);
        return false;
      }
      const $table = this.$refs.normal;
      let normalItem = _.cloneDeep(this.record);
      normalItem.workClassify = 10;
      normalItem.creationTimeSapn = new Date().getTime();
      this.normal.push(normalItem);
      await $table.setActiveRow(this.normalTableData[this.normalLength]);
    },
    async addBudget() {
      if (!this.expandBudgetStatus) {
        this.expandBudgetStatus = true;
        this.budget = _.cloneDeep(this.cloneBudget);
        this.cloneBudget = [];
      }
      if (this.budgetLength >= this.$config.workItemLength.month.budget) {
        this.$message.error(`最多可添加${this.$config.workItemLength.month.budget}条数据`);
        return false;
      }
      const $table = this.$refs.month;
      let normalItem = _.cloneDeep(this.record);
      normalItem.workClassify = 40;
      normalItem.creationTimeSapn = new Date().getTime();
      this.budget.push(normalItem);
      await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.budgetLength]);
    },
    async addCreate() {
      if (!this.expandCreateStatus) {
        this.expandCreateStatus = true;
        this.create = _.cloneDeep(this.cloneCreate);
        this.cloneCreate = [];
      }
      if (this.createLength >= this.$config.workItemLength.month.create) {
        this.$message.error(`最多可添加${this.$config.workItemLength.month.create}条数据`);
        return false;
      }
      const $table = this.$refs.month;
      let createItem = _.cloneDeep(this.record);
      createItem.workClassify = 20;
      createItem.creationTimeSapn = new Date().getTime();
      this.create.push(createItem);
      await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.budgetLength + this.createLength]);
    },
    async addOther() {
      if (!this.expandOtherStatus) {
        this.expandOtherStatus = true;
        this.other = _.cloneDeep(this.cloneOther);
        this.cloneOther = [];
      }
      const $table = this.$refs.month;
      let otherItem = _.cloneDeep(this.record);
      otherItem.workClassify = 30;
      otherItem.creationTimeSapn = new Date().getTime();
      this.other.push(otherItem);
      await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.budgetLength + this.createLength + this.otherLength]);
    },
    setRowClass({ row, rowIndex }) {
      if (
        rowIndex == 0 ||
        rowIndex == this.kpiLength + 1 ||
        rowIndex == this.kpiLength + this.budgetLength + 2 ||
        rowIndex == this.kpiLength + this.budgetLength + this.createLength + 3
      ) {
        return 'main-row';
      }else {
        if ((row.status === 35 || row.status === 40) && (row.completeStatus !== 20 && row.completeStatus !== 25 )) {
          return 'unfinished';
        }
      }
    },
    setNormalRowClass({ row, rowIndex }) {
      if (rowIndex == 0) {
        return 'main-row';
      }else {
        if ((row.status === 35 || row.status === 40) && (row.completeStatus !== 20 && row.completeStatus !== 25 )) {
          return 'unfinished';
        }
      }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    async save(row, index) {
       if (this.autoSaving) {
        this.isPreventSave = true;
      } else {
        this.pending = true;
        this.isPreventSave = false;
        this.tableData[index].weight = this.tableData[index].weight ? this.tableData[index].weight : 1;
        await this.$ajax
          .post(this.$api.month.MonthWorkDetail.detail, this.tableData[index], { noLoading: true })
          .then((res) => {
            const item = res.data;
            if (!row.id) {
              this.tableData.forEach(val => {
                if (row.creationTimeSapn === val.creationTimeSapn) {
                  val.id = item.id;
                  val.status = item.status;
                }
              })
            }
            // if (item.workClassify === 0) {
            //   if (this.expandKpiStatus) {
            //     this.kpi.splice(index - 1, 1, item);
            //   } else {
            //     this.cloneKpi.splice(index - 1, 1, item);
            //   }
            // }else if (item.workClassify === 40){
            //   if (this.expandBudgetStatus) {
            //     this.budget.splice(index - this.kpiLength - 2, 1, item);
            //   } else {
            //     this.cloneBudget.splice(index - this.kpiLength - 2, 1, item);
            //   }
            // }else if (item.workClassify === 20) {
            //   if (this.expandCreateStatus) {
            //     this.create.splice(index - this.kpiLength - this.budgetLength - 3, 1, item);
            //   } else {
            //     this.cloneCreate.splice(index - this.kpiLength - this.budgetLength - 3, 1, item);
            //   }
            // } else if (item.workClassify === 30) {
            //   if (this.expandOtherStatus) {
            //     this.other.splice(index - this.kpiLength - this.budgetLength - this.createLength - 4, 1, item);
            //   } else {
            //     this.cloneOther.splice(index - this.kpiLength - this.budgetLength - this.createLength - 4, 1, item);
            //   }
            // }
            this.saveStatus = '已保存';
            this.timeoutSave && clearTimeout(timeoutSave);
            const timeoutSave = setTimeout(
              () => {
                this.saveStatus = '';
              },
              1000,
              this
            );
            this.pending = false;
            this.$nextTick(() => {
              this.setMerge();
            });
          })
          .catch(() => {
            this.pending = false;
          });
      }
      // if (String(this.cloneTableData[index].workItemContent).length < this.$config.input.textareaMinLength ||
      //     String(this.cloneTableData[index].wholeTarget).length < this.$config.input.textareaMinLength ||
      //     String(this.cloneTableData[index].currentMonthTarget).length < this.$config.input.textareaMinLength
      // ) {
      //   this.$message.error("工作项,目标内容最少输入10个字符");
      //   return false
      // }
    },
    async saveNormal(row, index) {
      // if (String(this.cloneNormalTableData[index].workItemContent).length < this.$config.input.textareaMinLength ||
      //     String(this.cloneNormalTableData[index].wholeTarget).length < this.$config.input.textareaMinLength ||
      //     String(this.cloneNormalTableData[index].currentMonthTarget).length < this.$config.input.textareaMinLength
      // ) {
      //   this.$message.error("工作项,目标内容最少输入10个字符");
      //   return false
      // }
      if (this.autoSaving) {
        this.isPreventSave = true;
      } else {
        this.pending = true;
        this.normalTableData[index].weight = this.normalTableData[index].weight ? this.normalTableData[index].weight : 1;
        await this.$ajax
          .post(this.$api.month.MonthWorkDetail.detail, this.normalTableData[index], { noLoading: true })
          .then((res) => {
            const item = res.data;
            if (!row.id) {
              this.normalTableData.forEach(val => {
                if (row.creationTimeSapn === val.creationTimeSapn) {
                  val.id = item.id;
                  val.status = item.status;
                }
              })
            }
            this.saveStatus = '已保存';
            this.timeoutSaveNormal && clearTimeout(timeoutSaveNormal);
            const timeoutSaveNormal = setTimeout(
              () => {
                this.saveStatus = '';
              },
              1000,
              this
            );
            // this.$refs.normal.clearActived();
            this.$nextTick(() => {
              this.setNormalMerge();
            });
            this.pending = false;
            // this.$message.success('保存成功');
          })
          .catch(() => {
            this.pending = false;
          });
      }
    },
    async saveAuto(row, index) {
      this.autoSaving = true;
      this.tableData[index].weight = this.tableData[index].weight ? this.tableData[index].weight : 1;
      await this.$ajax
        .post(this.$api.month.MonthWorkDetail.detail, this.tableData[index], { noLoading: true })
        .then((res) => {
          const item = res.data;
          if (!row.id) {
            this.tableData.forEach(val => {
              if (row.creationTimeSapn === val.creationTimeSapn) {
                val.id = item.id;
                val.status = item.status;
              }
            })
          }
          this.saveStatus = '已保存';
          this.timeoutAutoSave && clearTimeout(timeoutAutoSave);
          const timeoutAutoSave = setTimeout(
            () => {
              this.saveStatus = '';
            },
            1000,
            this
          );
          this.autoSaving = false;
          if(this.isPreventSave) {
            this.save(row, index);
          }
          // this.$message.success('保存成功');
        })
        .catch(() => {
          this.autoSaving = false;
        });
    },
    async saveNormalAuto(row, index) {
      this.autoSaving = true;
      this.normalTableData[index].weight = this.normalTableData[index].weight ? this.normalTableData[index].weight : 1;
      await this.$ajax.post(this.$api.month.MonthWorkDetail.detail, this.normalTableData[index], { noLoading: true }).then((res) => {
        const item = res.data;
        if (!row.id) {
          this.normalTableData.forEach(val => {
            if (row.creationTimeSapn === val.creationTimeSapn) {
              val.id = item.id;
              val.status = item.status;
            }
          })
        }
        this.saveStatus = '已保存';
        this.timeoutAutoSaveNormal && clearTimeout(timeoutAutoSaveNormal);
        const timeoutAutoSaveNormal = setTimeout(
          () => {
            this.saveStatus = '';
          },
          1000,
          this
        );
        this.autoSaving = false;
        if(this.isPreventSave) {
          this.saveNormal(row, index);
        }
        // this.$message.success('保存成功');
      }).catch(() => {
        this.autoSaving = false;
      });
    },
    saveAll() {
      const arr = this.getAllTableData();
      const saveData = arr.filter(row => row.status != 40);
      if (saveData.length == 0) {
        this.$message.error('没有需要保存的数据');
      } else {
        this.$ajax.post(this.$api.month.MonthWorkDetail.addAll, saveData, { noLoading: true }).then(() => {
          this.$message.success('保存成功');
        });
      }
    },
    editClosed({ row, rowIndex }) {
      this.categoryAuth = true;
      this.normalAuth = true;
      this.completeAuth = true;
      this.fromOtherAuth = true;
      this.weightAuth = true;
      clearInterval(this.timer);
      if (rowIndex !== -1) {
        if (
          (this.editStatus == 'edit' && row.status !== 40 && row.status !== 35 && this.status !== 10) ||
          (this.status === 10 && this.editStatus == 'approve')
        ) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
          this.$refs.month.updateData(this.tableData);
          this.save(row, rowIndex);
        }
      }
    },
    activeRow({ row, rowIndex }) {
      this.row = row;
      this.rowIndex = rowIndex;
      clearInterval(this.timer);
      if (
        (this.editStatus == 'edit' && row.status !== 40 && row.status !== 35 && this.status !== 10) ||
        (this.status === 10 && this.editStatus == 'approve')
      ) {
        this.timer = setInterval(() => {
          this.saveAuto(row, rowIndex);
        }, 10000);
      }
    },
    firstPromise(promiseFunction) {
      let p = null;
      return function (...args) {
        // 请求的实例，已存在意味着正在请求中，直接返回实例，不触发新的请求
        return p
          ? p
          // 否则发送请求，且在finally时将p置空，那么下一次请求可以重新发起
          : (p = promiseFunction.apply(this, args).finally(() => (p = null)));
      };
    },
    editNormalClose({ row, rowIndex }) {
      this.categoryAuth = true;
      this.normalAuth = true;
      this.completeAuth = true;
      this.fromOtherAuth = true;
      this.weightAuth = true;
      clearInterval(this.timer);
      if (rowIndex !== -1) {
        if (
          (this.editStatus == 'edit' && row.status !== 40 && row.status !== 35 && this.status !== 10) ||
          (this.status === 10 && this.editStatus == 'approve')
        ) {
          if(this.$getRowExpandFlag()) this.normalTableData[rowIndex].expandRowFlag = false;
          this.$refs.normal.updateData(this.tableData);
          this.saveNormal(this.normalTableData[rowIndex], rowIndex);
        }
      }
    },
    activeNormalRow({ row, rowIndex }) {
      this.normalRow = row;
      this.normalRowIndex = rowIndex;
      clearInterval(this.timer);
      if (
        (this.editStatus == 'edit' && row.status !== 40 && row.status !== 35 && this.status !== 10) ||
        (this.status === 10 && this.editStatus == 'approve')
      ) {
        this.timer = setInterval(() => {
          this.saveNormalAuto(row, rowIndex);
        }, 10000);
      }
    },
    weightSearch(queryString, cb) {
      let programList = this.weightList;
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    // querySearch(queryString, cb) {
    //   let programList = this.programList;
    //   // 调用 callback 返回建议列表的数据
    //   cb(programList);
    // },
    querySearch(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      let results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    async copyData(row, index) {
      const $table = this.$refs.month;
      const item = _.cloneDeep(row);
      delete item._XID;
      delete item.id;
      item.status = 100;
      item.source = 0;
      item.finishDate = '';
      item.creationTimeSapn = new Date().getTime();
      let length = 0;

      if (index <= this.kpiLength) {
        if (this.kpiLength >= this.$config.workItemLength.month.kpi) {
          this.$message.error(`最多可添加${this.$config.workItemLength.month.kpi}条数据`);
          return false;
        }
        this.kpi.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength]);
        length = this.kpiLength;
      } else if (index > this.kpiLength + 1 && index <= this.budgetLength + this.kpiLength + 2) {
        if (this.normalLength >= this.$config.workItemLength.month.normal) {
          this.$message.error(`最多可添加${this.$config.workItemLength.month.normal}条数据`);
          return false;
        }
        this.budget.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.budgetLength]);
        length = this.kpiLength + this.budgetLength + 1;
      } else if (index > this.budgetLength + this.kpiLength + 2 && index <= this.budgetLength + this.kpiLength + this.createLength + 3) {
        if (this.budgetLength >= this.$config.workItemLength.month.budget) {
          this.$message.error(`最多可添加${this.$config.workItemLength.month.budget}条数据`);
          return false;
        }
        this.create.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.budgetLength + this.createLength]);
        length = this.kpiLength + 2 + this.budgetLength + this.createLength;
      } else {
        this.other.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.budgetLength + this.createLength + this.otherLength]);
        length = this.kpiLength + 3 + this.budgetLength + this.createLength + this.otherLength;
      }
      // this.$nextTick(() => {
      //   this.saveAuto(item, length);
      // });
    },
    copyNormal(row) {
      if (this.normalLength >= this.$config.workItemLength.month.normal) {
        this.$message.error(`最多可添加${this.$config.workItemLength.month.normal}条数据`);
        return false;
      }
      const item = _.cloneDeep(row);
      delete item._XID;
      delete item.id;
      item.status = 100;
      item.source = 0;
      item.finishDate = '';
      item.creationTimeSapn = new Date().getTime();
      this.normal.push(item);
      const $table = this.$refs.normal;
      $table.setActiveRow(this.normalTableData[this.normalLength]);
      // this.$nextTick(() => {
      //   this.saveNormalAuto(item, this.normalLength);
      // });
    },
    deleteData(row, index) {
      if (row.id) {
        this.$ajax.delete(this.$api.month.MonthWorkDetail.detail + '/' + row.id).then(() => {
          const item = row;
          if (item.workClassify === 0) {
            _.remove(this.kpi, t => t.id == item.id);
            this.kpi.splice(0,0);
          }else if (item.workClassify === 40){
            _.remove(this.budget, t => t.id == item.id);
            this.budget.splice(0,0);
          }else if (item.workClassify === 20) {
            _.remove(this.create, t => t.id == item.id);
            this.create.splice(0,0);
          } else if (item.workClassify === 30) {
            _.remove(this.other, t => t.id == item.id);
            this.other.splice(0,0);
          }
          clearInterval(this.timer);
          this.$message.success('删除成功');
        });
      } else {
        if (index <= this.kpiLength) {
          this.kpi.splice(index - 1, 1);
        } else if (index > this.kpiLength + 1 && index <= this.budgetLength + this.kpiLength + 2) {
          this.budget.splice(index - this.kpiLength - 2, 1);
        } else if (index > this.budgetLength + this.kpiLength + 2 && index <= this.budgetLength + this.kpiLength + this.createLength + 3) {
          this.create.splice(index - this.kpiLength - this.budgetLength - 3, 1);
        } else {
          this.other.splice(index - this.kpiLength - this.budgetLength - this.createLength - 4, 1);
        }
        clearInterval(this.timer);
        this.$message.success('删除成功');
      }
    },
    deleteNormal(row, index) {
      if (row.id) {
        this.$ajax.delete(this.$api.month.MonthWorkDetail.detail + '/' + row.id).then(() => {
          _.remove(this.normal, t => t.id == row.id);
            this.normal.splice(0,0);
          clearInterval(this.timer);
          this.$message.success('删除成功');
        });
      } else {
        this.normal.splice(index - 1, 1);
        clearInterval(this.timer);
        this.$message.success('删除成功');
      }
    },
    getSelect() {
      let check1 = this.$refs.month.getCheckboxRecords();
      let check2 = this.$refs.normal.getCheckboxRecords();
      let check = [...check1, ...check2];
      let data = check.filter((val) => val.workId !== undefined);
      this.selecterData = _.cloneDeep(data);
      const res = data.map((val) => {
        const { id, reason, completeStatus } = val;
        return { id: id, reason: reason, completeStatus: completeStatus };
      });
      return res;
    },
    toToDoWork() {
      this.$router.push('/personal/todo-work/index');
    },
    submitHandle() {
      // 计划提交
      this.submitLimitMsg = [];
      const allTableData = [...this.tableData, ...this.normalTableData ];

      const currentDept = (this.detail.department || '').split('\\\\').join('\\');
      let currentDeptNoLimits = [];
      this.noMinLimits.forEach(item => {
        if (currentDept.includes(item.itemKey)) {
          let vals = (item.itemValue || '').split(/,|，/);
          vals = vals.filter(v => v !== '');
          if (vals.length > 0) currentDeptNoLimits.push(...vals);
        }
      })
      currentDeptNoLimits = [...new Set(currentDeptNoLimits)];

      this.minLimits.forEach(item => {
        const classifyData = allTableData.filter(row => row.workClassify == item.workClassify);
        if ((item.minLimit || item.minLimit === 0) && classifyData.length < item.minLimit && !currentDeptNoLimits.includes(item.workClassify + '')) {
          this.submitLimitMsg.push(item);
        }
      });
      if (['0', '30', 0, 30].includes(this.status)) {
        if (this.submitLimitMsg.length > 0) {
          this.showSubmitTip = true;
        } else {
          this.showSubmit = true;
        }
      } else if (['20', '40', '60', '70', 20, 40, 60, 70].includes(this.status)) {
        // 总结提交
        if (this.submitLimitMsg.length > 0) {
          this.showSubmitSummaryTip = true;
        } else {
          this.showSubmit = true;
        }
      } else {
        this.showSubmit = true;
      }
    },
    async submit() {
      // 校验数据填写情况
      this.showSubmit = false;
      this.showSubmitTip = false;
      this.showSubmitSummaryTip = false;
      if (this.getAllTableData().length === 0) {
        this.$message.warning('请填写工作项后再提交');
        return false;
      }
      this.changeModel("1", "submit");
      this.model = "1";
      const validateObj = {};
      const validateObjNormal = {};
      this.expandAll();
      this.setMerge();
      this.$nextTick(async () => {
        let check1 = this.$refs.month.getCheckboxRecords().filter((val) => val.workId !== undefined);
        let check2 = this.$refs.normal.getCheckboxRecords().filter((val) => val.workId !== undefined);
        const data = this.tableData.filter((t) => typeof t.id !== 'undefined');
        if (this.status === 0 || this.status === 30 || this.status === 100) {
          validateObj.value = data;
          validateObjNormal.value = this.normal;
        } else {
          if (check1.length) {
            validateObj.value = check1;
          } else {
            if (check2.length) {
              validateObj.value = false;
            } else {
              validateObj.value = data;
            }
          }
          if (check2.length) {
            validateObjNormal.value = check2;
          } else {
            if (check1.length) {
              validateObjNormal.value = false;
            } else {
              validateObjNormal.value = this.normal;
            }
          }
        }
        const $table = this.$refs.month;
        const errMap = await $table.validate(validateObj.value).catch((errMap) => errMap);
        const $normal = this.$refs.normal;
        const errMapNormal = await $normal.validate(validateObjNormal.value).catch((errMapNormal) => errMapNormal);
        Promise.all([errMap, errMapNormal]).then((res) => {
          if (res[0]) {
            this.currentTab = 0;
            // this.changeModel(this.model);
            const msgList = [];
            Object.values(res[0]).forEach((errList) => {
              errList.forEach((params) => {
                const { column, rules } = params;
                rules.forEach((rule) => {
                  msgList.push(`${column.title} 校验错误：${rule.message}`);
                });
              });
            });
            this.$message({
              type: 'error',
              message: msgList.join(),
            });
            return false;
          }
          if (res[1]) {
            const msgList = [];
            this.currentTab = 1;
            // this.changeModel(this.model);
            Object.values(res[1]).forEach((errList) => {
              errList.forEach((params) => {
                const { column, rules } = params;
                rules.forEach((rule) => {
                  msgList.push(`${column.title} 校验错误：${rule.message}`);
                });
              });
            });
            this.$message({
              type: 'error',
              message: msgList.join(),
            });
            return false;
          }
          if (this.status === 0 || this.status === 30 || this.status === 100) {
            //校验工作项
            this.$ajax.put(this.$api.month.MonthWorkDetail.submit, { workId: this.workId }).then(() => {
              this.$message.success('提交成功');
              this.reload();
            });
          } else if (this.status === 20) {
            //任务全部完成 给出提示不在允许提交
            const arr = this.getSelect();
            let select = [...check1, ...check2];
            if (arr.length) {
              let allComplete = select.every((item) => {
                return item.status === 40 || item.status === 35;
              });
              if (allComplete) {
                this.$message.success('任务已提交，您无需重复提交。');
                return false;
              }
              this.$ajax.put(this.$api.month.MonthWorkDetail.commitComplete, arr).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            } else {
              const arr = this.getAllTableData();
              let allComplete = arr.every((item) => {
                return item.status === 40 || item.status === 35;
              });
              if (allComplete) {
                this.$message.success('任务已提交，您无需重复提交。');
                return false;
              }
              const list = arr.map((val) => {
                const { id, reason, completeStatus } = val;
                return { id: id, reason: reason, completeStatus: completeStatus };
              });
              this.$ajax.put(this.$api.month.MonthWorkDetail.commitComplete, list).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            }
          } else {
            this.showSubmit = false;
            this.$message.error('当前状态您的计划已无法提交！');
          }
        });
      });
    },
    updateStatus(status) {
      if (this.status === 10) {
        //员工提交工作项目 待审批状态
        if (status == 'access') {
          this.showApprove = false;
          this.$ajax
            .put(this.$api.month.MonthWorkDetail.updateAllStatus, {
              workId: this.workId,
              status: 20,
              approveReason: this.approveReason,
              msgId: this.msgId,
            })
            .then((res) => {
              this.$message.success(res.message);
              this.reload();
            });
        } else {
          if (this.approveReason) {
            this.showCompleteApprove = false;
            this.$ajax
              .put(this.$api.month.MonthWorkDetail.updateAllStatus, {
                workId: this.workId,
                status: 30,
                approveReason: this.approveReason,
                msgId: this.msgId,
              })
              .then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
          } else {
            this.$message.error('必须填写驳回原因');
          }
        }
      } else if (this.status === 20) {
        const arr = this.getSelect();
        let check1 = this.$refs.month.getCheckboxRecords().filter((val) => val.workId !== undefined);
        let check2 = this.$refs.normal.getCheckboxRecords().filter((val) => val.workId !== undefined);
        let check = [...check1, ...check2];
        // 工作计划审批通过的数据进入审批完成情况里禁止操作 判断每条数据是否都是20如果是禁止操作 因为工作总结的状态是35
        let approveFlag = false;
        if (arr.length) {
          approveFlag = check.every((val) => val.status === 20);
        } else {
          const arr = this.getAllTableData();
          approveFlag = arr.every((val) => val.status === 20);
        }
        if (approveFlag) {
          this.$message.error('当前状态不能再被审批');
          return false;
        }
        let res = status === 'access' ? 40 : 50;
        if (status == 'access') {
          if (this.approveRow) {
            // 如果是单条审批
            this.$ajax
              .put(this.$api.month.MonthWorkDetail.updateStatus, [
                {
                  id: this.approveRow.id,
                  status: res,
                  workId: this.workId,
                  approveReason: this.approveReason,
                  msgId: this.msgId,
                },
              ])
              .then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
          } else {
            const list = arr.map((val) => {
              const { id } = val;
              return { id: id, status: 40, workId: this.workId, approveReason: this.approveReason, msgId: this.msgId };
            });
            this.showApprove = false;

            //工作状态变更待审批状态
            if (list.length) {
              let approveStatus = check.every((val) => val.status === 40 || val.status === 50);
              if (approveStatus) {
                this.$message.error('当前状态不能再被审批');
                return false;
              }
              this.$ajax.put(this.$api.month.MonthWorkDetail.updateStatus, list).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            } else {
              const arr = this.getAllTableData();
              const list = arr.map((val) => {
                const { id } = val;
                return { id: id, status: 40, workId: this.workId, approveReason: this.approveReason, msgId: this.msgId };
              });
              this.$ajax.put(this.$api.month.MonthWorkDetail.updateStatus, list).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            }
          }
        } else {
          if (!this.approveReason) {
            this.$message.error('必须填写驳回原因');
            return false;
          }
          this.showCompleteApprove = false;
          // 驳回
          if (this.approveRow) {
            // 如果是单条审批
            this.$ajax
              .put(this.$api.month.MonthWorkDetail.updateStatus, [
                {
                  id: this.approveRow.id,
                  status: res,
                  workId: this.workId,
                  approveReason: this.approveReason,
                  msgId: this.msgId,
                },
              ])
              .then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
          } else {
            const list = arr.map((val) => {
              const { id } = val;
              return { id: id, status: 50, workId: this.workId, approveReason: this.approveReason, msgId: this.msgId };
            });
            //工作状态变更待审批状态
            if (list.length) {
              let approveStatus = check.every((val) => val.status === 40 || val.status === 50);
              if (approveStatus) {
                this.$message.error('当前状态不能再被审批');
                return false;
              }
              this.$ajax.put(this.$api.month.MonthWorkDetail.updateStatus, list).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            } else {
              const arr = this.getAllTableData();

              const list = arr.map((val) => {
                const { id } = val;
                return { id: id, status: 50, workId: this.workId, approveReason: this.approveReason, msgId: this.msgId };
              });
              this.$ajax.put(this.$api.month.MonthWorkDetail.updateStatus, list).then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
            }
          }
        }
      } else {
        this.$message.error('当前状态不能再被审批');
      }
    },
    editActived({ row }) {
      //审批状态
      if (this.editStatus == 'approve') {
        //审批工作项
        if (row.status === 10) {
          this.categoryAuth = true;
          this.normalAuth = true;
          this.completeAuth = false;
          this.fromOtherAuth = true;
          this.weightAuth = true;
          if (row.source === 2) {
            //来源于上月未完成的情况允许再次编辑权重
            this.categoryAuth = false;
            this.normalAuth = false;
            this.completeAuth = false;
            this.fromOtherAuth = true;
            this.weightAuth = true;
          }
          //领导审批来自年同步信息
          if (row.source === 4) {
            this.categoryAuth = false;
            this.normalAuth = false;
            this.completeAuth = false;
            this.fromOtherAuth = true;
            this.weightAuth = true;
          }
        } else {
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = false;
          this.fromOtherAuth = false;
          this.weightAuth = false;
        }
      } else if (this.editStatus == 'edit') {
        if (row.status === 10) {
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = false;
          this.fromOtherAuth = false;
          this.weightAuth = false;
        } else if (row.status === 20) {
          //已提交 已审核 控制可编辑工作状态
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = true;
          this.fromOtherAuth = false;
          this.weightAuth = false;
          //来源于发布工作 可编辑完成情况和月目标
          if (row.source === 1 || row.source === 3 || row.source === 5 || row.source === 7 || row.source === 8 || row.source === 9) {
            this.categoryAuth = true;
            this.normalAuth = false;
            this.completeAuth = true;
            this.fromOtherAuth = true;
            this.weightAuth = false;
          }
        } else if (row.status === 30 || row.status === 0 || row.status === 100) {
          if (row.source === 2) {
            //来源于上月未完成的情况允许再次编辑权重
            this.categoryAuth = false;
            this.normalAuth = false;
            this.completeAuth = false;
            this.fromOtherAuth = true;
            this.weightAuth = true;
          } else if (row.source === 4) {
            this.categoryAuth = false;
            this.normalAuth = false;
            this.completeAuth = false;
            this.fromOtherAuth = true;
            this.weightAuth = true;
          } else {
            //驳回或者初始编辑状态 全部可编辑
            this.categoryAuth = true;
            this.normalAuth = true;
            this.completeAuth = false;
            this.fromOtherAuth = true;
            this.weightAuth = true;
          }
        } else if (row.status === 50) {
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = true;
          this.fromOtherAuth = false;
          this.weightAuth = false;
        } else {
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = false;
          this.fromOtherAuth = false;
          this.weightAuth = false;
        }
        // 提交状态下 禁止一切编辑活动
        if (this.status === 10) {
          this.categoryAuth = false;
          this.normalAuth = false;
          this.completeAuth = false;
          this.fromOtherAuth = false;
          this.weightAuth = false;
        }
      } else {
        //预览状态
        this.categoryAuth = false;
        this.normalAuth = false;
        this.completeAuth = false;
        this.fromOtherAuth = false;
        this.weightAuth = false;
      }
      return true;
    },
    move(row) {
      this.showHandle = true;
      this.nowClassify = row;
      this.classify = row.workClassify;
    },
    confirmClassify() {
      this.showHandle = false;
      this.$ajax
        .put(this.$api.month.MonthWorkDetail.updateWorkClassify, {
          id: this.nowClassify.id,
          workClassify: this.classify,
        })
        .then(() => {
          this.getList();
          this.$message.success('更改工作分类成功');
        });
    },
    async commitComplete(row, rowIndex) {
      clearInterval(this.timer);
      // this.changeModel("1");
      // this.model = "1";
      if (this.currentTab === 0) {
        await this.saveAuto(row, rowIndex);
        const $table = this.$refs.month;
        const errMap = await $table.validate(this.tableData[rowIndex]).catch((errMap) => errMap);
        if (errMap) {
          //  this.editActived({
          //   row: this.tableData[rowIndex],
          //   rowIndex: rowIndex
          // })
          const msgList = [];
          Object.values(errMap).forEach((errList) => {
            errList.forEach((params) => {
              const { column, rules } = params;
              rules.forEach((rule) => {
                msgList.push(`${column.title} 校验错误：${rule.message}`);
              });
            });
          });
          this.$message({
            type: 'error',
            message: msgList.join(),
          });
          return false;
        } else {
          this.$ajax
            .put(this.$api.month.MonthWorkDetail.commitComplete, [
              {
                id: row.id,
                completeStatus: row.completeStatus,
                reason: row.reason,
              },
            ])
            .then((res) => {
              this.$message.success(res.message);
              this.reload();
            });
        }
      } else {
        await this.saveNormalAuto(row, rowIndex);
        const $table = this.$refs.normal;
        const errMap = await $table.validate(this.normalTableData[rowIndex]).catch((errMap) => errMap);
        if (errMap) {
          //  this.editActived({
          //   row: this.normalTableData[rowIndex],
          //   rowIndex: rowIndex
          // })
          const msgList = [];
          Object.values(errMap).forEach((errList) => {
            errList.forEach((params) => {
              const { column, rules } = params;
              rules.forEach((rule) => {
                msgList.push(`${column.title} 校验错误：${rule.message}`);
              });
            });
          });
          this.$message({
            type: 'error',
            message: msgList.join(),
          });
          return false;
        } else {
          this.$ajax
            .put(this.$api.month.MonthWorkDetail.commitComplete, [
              {
                id: row.id,
                completeStatus: row.completeStatus,
                reason: row.reason,
              },
            ])
            .then((res) => {
              this.$message.success(res.message);
              this.reload();
            });
        }
      }
    },

    complete(row, rowIndex, status) {
      this.approveRow = _.cloneDeep(row);
      if (status === 'access') {
        this.showApprove = true;
      } else {
        this.showCompleteApprove = true;
      }
    },
    closeApprove() {
      this.approveReason = '';
      this.approveRow = null;
    },
    // complete(row, rowIndex, status) {
    //   let res = status === "access" ? 40 : 50;
    //   this.$ajax.put(this.$api.month.MonthWorkDetail.updateStatus, [{
    //     id: row.id,
    //     status: res,
    //     workId: this.workId
    //   }]).then(() => {
    //     this.$message.success('审批成功');
    //   });
    // },
    getAddWork(row) {
      this.$ajax
        .get(
          this.$api.month.MonthWorkDetail.release,
          {
            id: row.id,
          },
          { noLoading: true }
        )
        .then((res) => {
          this.programData = res.data;
        });
    },
    checkAll(e) {
      if (e) {
        this.checkList = this.programData.map((val) => val.id);
      } else {
        this.checkList = [];
      }
    },
    copyProgram() {
      const arr = this.programData.filter((val) => this.checkList.indexOf(val.id) !== -1);
      if (arr.length === 0) {
        this.$message({
          message: '请先勾选数据',
          type: 'error',
        });
        return false;
      }
      let text = '';
      arr.forEach((val) => {
        text += val.workItemContent;
      });
      let oInput = document.createElement('input');
      oInput.value = text;
      oInput.className = 'copy-text';
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
      });
    },
    popupHistory(row) {
      if (row.source === 2) {
        this.showHistory = true;
        this.$ajax
          .get(
            this.$api.month.MonthWorkDetail.history,
            {
              id: row.id,
            },
            { noLoading: true }
          )
          .then((res) => {
            this.historyData = res.data;
          });
      }
    },
    expandKpi() {
      // if(this.kpiLength === 0 || this.cloneKpi.length === 0) {
      //   return false;
      // }
      this.setMerge();
      this.expandKpiStatus = !this.expandKpiStatus;
      if (this.expandKpiStatus) {
        this.kpi = _.cloneDeep(this.cloneKpi);
        this.cloneKpi = [];
      } else {
        this.cloneKpi = _.cloneDeep(this.kpi);
        this.kpi = [];
      }
    },
    expandNormal() {
      // if(this.budgetLength === 0) {
      //   return false;
      //
      this.setMerge();
      this.expandBudgetStatus = !this.expandBudgetStatus;
      if (this.expandBudgetStatus) {
        this.budget = _.cloneDeep(this.cloneBudget);
        this.cloneBudget = [];
      } else {
        this.cloneBudget = _.cloneDeep(this.budget);
        this.budget = [];
      }
    },
    expandCreate() {
      // if(this.createLength === 0) {
      //   return false;
      // }
      this.setMerge();
      this.expandCreateStatus = !this.expandCreateStatus;
      if (this.expandCreateStatus) {
        this.create = _.cloneDeep(this.cloneCreate);
        this.cloneCreate = [];
      } else {
        this.cloneCreate = _.cloneDeep(this.create);
        this.create = [];
      }
    },
    expandOther() {
      // if(this.otherLength === 0) {
      //   return false;
      // }
      this.setMerge();
      this.expandOtherStatus = !this.expandOtherStatus;
      if (this.expandOtherStatus) {
        this.other = _.cloneDeep(this.cloneOther);
        this.cloneOther = [];
      } else {
        this.cloneOther = _.cloneDeep(this.other);
        this.other = [];
      }
    },
    expandAll() {
      if (!this.expandKpiStatus) {
        this.expandKpiStatus = !this.expandKpiStatus;
        this.kpi = _.cloneDeep(this.cloneKpi);
      }
      if (!this.expandBudgetStatus) {
        this.expandBudgetStatus = !this.expandBudgetStatus;
        this.budget = _.cloneDeep(this.cloneBudget);
      }
      if (!this.expandCreateStatus) {
        this.expandCreateStatus = !this.expandCreateStatus;
        this.create = _.cloneDeep(this.cloneCreate);
      }
      if (!this.expandOtherStatus) {
        this.expandOtherStatus = !this.expandOtherStatus;
        this.other = _.cloneDeep(this.cloneOther);
      }
    },
    changeModel(e, submit) {
      const arr = this.tableColumn.filter((val) => val.title !== undefined);
      const arr1 = this.normalColumn.filter((val) => val.title !== undefined);
      let list = [];
      // let fixRight;
      // let fixRightNormal;
      switch (e) {
        case '1':
          list = [];
          if(localStorage.getItem("month_table_herder") && this.editStatus === "edit" && !submit){
            let cache = JSON.parse(localStorage.getItem("month_table_herder"));
            this.tableColumn.forEach(v => {
              cache.forEach(t => {
                if (v.title == t.title){
                  v.visible = t.visible;
                }
              })
            })
            this.normalColumn.forEach(v => {
              cache.forEach(t => {
                if (v.title == t.title){
                  v.visible = t.visible;
                }
              })
            })
            this.$refs.month && this.$refs.month.refreshColumn();
            this.$refs.normal && this.$refs.normal.refreshColumn();
          }else {
            this.tableColumn.forEach((val) => {
              val.visible = true;
            });
            this.normalColumn.forEach((val) => {
              val.visible = true;
            });
          }
          this.isCollapse = false;
          this.isNormalCollapse = false;
          setTimeout(() => {
            this.setPosition(null, 'kpi');
            // this.observerClass("kpi");
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }, 50);
          break;
        case '2':
          this.isCollapse = false;
          this.isNormalCollapse = false;
          list = ['类别', '工作项目', '总目标', '总目标完成时间', '本月需达到的目标', '本月目标完成时间', '权重', '提交状态', '操作'];
          break;
        case '3':
          list = ['类别', '工作项目', '总目标', '总目标完成时间', '本月需达到的目标', '本月目标完成时间', '完成情况', '总结', '提交状态', '操作'];
          this.isCollapse = false;
          this.isNormalCollapse = false;
          setTimeout(() => {
            this.setPosition(null, 'kpi');
            // this.observerClass("kpi");
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }, 50);
          break;
        case '4':
          list = ['工作项目', '本月需达到的目标', '完成情况', '总结'];
          this.showCollapse = false;
          break;
      }
      if (list.length) {
        arr.forEach((val) => {
          if (list.indexOf(val.title) !== -1) {
            val.visible = true;
          } else {
            val.visible = false;
          }
        });
        arr1.forEach((val) => {
          if (list.indexOf(val.title) !== -1) {
            val.visible = true;
          } else {
            val.visible = false;
          }
        });
      }
      let promise1 = this.$refs.month.refreshColumn();
      let promise2 = this.$refs.normal.refreshColumn();
      Promise.all([promise1, promise2]).then(() => {
        if (e == 2) {
          if (this.currentTab === 0) {
            if (document.getElementsByClassName('kpi')[0].getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
              setTimeout(() => {
                this.setPosition(null, 'kpi');
              }, 50);
            } else {
              this.showCollapse = false;
            }
          } else {
            if (document.getElementsByClassName('normal')[0].getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
              setTimeout(() => {
                this.setPosition(null, 'normal');
              }, 50);
            } else {
              this.showCollapse = false;
            }
          }
        }
      });
      this.setMerge();
    },
    setMerge() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.budgetLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.budgetLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ];
    },
    setNormalMerge() {
      this.mergeNormal = [{ row: 0, col: 0, rowspan: 1, colspan: this.normalColumnLength }];
    },
  },
  watch: {
    tableData: {
      handler() {
        // this.cloneTableData = _.cloneDeep(val);
        // if (this.row.id && this.currentTab === 0) {
        //   this.cloneTableData[this.rowIndex].id = this.row.id;
        //   this.cloneTableData[this.rowIndex].status = this.row.status;
        // }
      },
      deep: true,
    },
    normalTableData: {
      handler() {
        // this.cloneNormalTableData = _.cloneDeep(val);
        // if (this.normalRow.id && this.currentTab === 1) {
        //   this.cloneNormalTableData[this.normalRowIndex]['id'] = this.normalRow.id;
        //   this.cloneNormalTableData[this.normalRowIndex].status = this.normalRow.status;
        // }
      },
      deep: true,
    },
    tableColumnLength() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.budgetLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.budgetLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ];
    },
    normalColumnLength() {
      this.mergeNormal = [{ row: 0, col: 0, rowspan: 1, colspan: this.normalColumnLength }];
    },
    kpiLength() {
      this.setMerge();
    },
    budgetLength() {
      this.setMerge();
    },
    normalLength() {
      this.setNormalMerge();
    },
    createLength() {
      this.setMerge();
    },
    otherLength() {
      this.setMerge();
    },
  },
};
</script>
<style scoped lang="scss">
.month {
  height: 100%;
  .header {
    margin-top: -5px;
    .month-title {
      padding: 0 10px;
      line-height: 30px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
  }
  .container {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
    .tab{
      .el-icon-arrow-down{
        font-size: 12px;
      }
      .open{
        padding-top: 8px;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
    }
    .search-and-content {
      flex: 1;
      overflow: auto;
      .search{
        .function{
          flex-wrap: wrap;
          .model{
            
          }
        }
      }
      .table-content {
        position: relative;
        .collapse {
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          top: -100px;
          &:hover {
            background-color: rgba(#000, 0.2);
          }
          i {
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .atb-input {
        display: flex;
        .flex-form-item {
          margin-bottom: 12px;
          display: flex;
          flex: 1;
        }
        .read-mode {
          align-self: flex-end;
        }
        ::v-deep.el-form-item__content {
          flex: 1;
          .el-select,
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }
    .kpi-content {
      overflow: auto;
      flex-grow: 1;
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
      // .unfinished-color{
      //     .vxe-cell{
      //       color: rgb(254, 107, 104);
      //     }
      //   }
      .unfinished{
        // background: rgb(255, 231, 231);
        .vxe-cell{
            color: rgb(254, 107, 104);
          }
      }
    }
    .kpi-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
  .el-dialog {
    &.history {
      .content {
        height: 400px;
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: left;
    .sub-content {
      text-align: center;
    }
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
  .normal-form {
    width: 80%;
  }
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}
::v-deep .el-radio {
  margin-right: 10px;
}
::v-deep .el-radio-button {
  margin-right: 20px;
  margin-bottom: 15px;
  .el-radio-button__inner {
    border-radius: 20px;
    padding: 0 20px;
    width: 100%;
    line-height: 36px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
  }
}
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  color: $--color-white;
}
.program-check {
  li {
    &:not(:last-child) {
      padding-bottom: 20px;
    }
    .el-checkbox__label {
      span {
        font-weight: bold;
      }
    }
    div {
      flex-grow: 1;
      margin-left: 15px;
      p {
        color: $--color-text-primary;
        font-size: 14px;
        &.desc {
          line-height: 1.5;
        }
        &.date {
          line-height: 1;
          margin-top: 10px;
        }
      }
    }
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.source-icon {
  font-size: 22px;
  &.add {
    color: #22b6a1;
  }
  &.self {
    color: #ffbe4a;
  }
  &.year {
    color: #4ece7d;
  }
  &.pre {
    color: #40c3f2;
  }
  &.zhuan {
    color: #4d82f7;
  }
  &.jiao {
    color: #ff8e50;
  }
  &.todo {
    color: #878a00;
  }
}
.submit-limit-tip {
  &.submit-summary {
    .submit-tip-label {
      white-space: nowrap;
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 16px!important;
    line-height: 1.5;
    text-align: center;
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  .submit-limit-icon {
    color: #d9b974;
    font-size: 40px;
    &.el-icon-question {
      color: #11a7ea;
    }
  }
  h2.submit-limit-title {
    margin: 10px 0;
    font-weight: normal;
    font-size: 16px;
  }
  .submit-tip-wrap {
    margin: 10px 0;
    padding: 10px;
    background-color: #f6f8fa;
    border-radius: 2px;
    text-align: left;
    line-height: 1.5;
  }
  .submit-tip-text {
    text-align: left;
    font-size: 14px;
  }
  .submit-tip-link {
    color: $--color-primary;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .submit-tip-content {
    font-weight: bold;
  }
  .submit-tip-item {
    margin-bottom: 2px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
